import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/shared-modules/services/auth.service';
import { RazorpayLoaderService } from 'src/app/shared-modules/services/razorpay-loader.service';
import { SubExpiredService } from '../sub-expired.service';
import { RestrictPlanService } from 'src/app/components/restrict-plan.service';

@Component({
  selector: 'fyt-sub-expired-popup',
  templateUrl: './sub-expired-popup.component.html',
  styleUrls: ['./sub-expired-popup.component.css']
})
export class SubExpiredPopupComponent implements OnInit, OnDestroy {
  @Input() InputObj;
  @Output() OutputObj1 = new EventEmitter<any>();
  renewPlan: boolean = true;
  paydata: any;
  renewPlanData: any;
  url: any;
  loader: boolean = false;
  rzpLoading: boolean = false;
  onlinePayFlag: boolean = false;
  renewPlanFlag: boolean = false;
  gymPlanStatus: boolean = false;
  message: string;
  op = 2000;
  sp = 1000;

  constructor(
    public router: Router,
    private authService: AuthService,
    public subExpiredService: SubExpiredService,
    private snackbar: MatSnackBar,
    private razorpayLoader: RazorpayLoaderService,
    private restrictPlanService: RestrictPlanService
  ) { }

  ngOnInit() {
    if (this.InputObj.pendingBalance > 0) this.renewPlan = false;
    this.messageContent();
  }

  goRenewPlan() {
    this.router.navigate(['/services/features-plan/crm']);
    this.gymPlanStatus = true
  }

  // Overdue payment holds the panel, but the Admin can still work find-a-centre leads
  // (docs/plan-find-centre-leads.md P6 decision 2026-10-18): only the Lead Dashboard opens;
  // every other page keeps showing this pop-up. Shown where the Lead Dashboard itself is shown
  // (side-nav rule: lead-only plan, or environment.showLeadDashboard) and only to the Admin.
  get showLeadDashboardButton(): boolean {
    let user: any = null;
    try { user = JSON.parse(localStorage.getItem('userDetails') || 'null'); } catch (e) { }
    if (!user || user.role !== 'Admin') { return false; }
    return this.restrictPlanService.canSeeLeadDashboard();
  }

  openLeadDashboard() {
    this.rzpLoading = false;
    this.router.navigate(['/gym/dashboard/lead']);
    this.OutputObj1.emit({ flag: 'leads', page: 'subExpiredPopUp' });
  }

  contactUs() {
    window.open('tel:08062616568', '_blank');
  }

  closeDialog(flag) {
    this.rzpLoading = false;
    this.OutputObj1.emit({ flag: flag, page: 'subExpiredPopUp' });
  }

  payBalance() {
    this.razorpayLoader.preload();
    this.loader = true;
    let postObj = {
      adminPlanId: this.InputObj.adminPlanId,
      paidAmount: this.InputObj.pendingBalance
    }

    //don't remove paytm payment flow
    // this.subExpiredService.payAllPartialPayment(postObj).subscribe((res) => {
    //   if (res.statusCode == "001") {
    //     this.paydata = res.paytmData;
    //     this.url = res.url;
    //     this.loader = false;
    //     this.onlinePayFlag = true;
    //   } else if (res.statusCode == "002") {
    //     this.loader = false;
    //   }
    // });

    this.subExpiredService.razorpayPartialPayment(postObj).subscribe((res) => {
      if (res.statusCode == "001") {
        this.paydata = res.payload;
        // this.url = res.url;
        this.loader = false;
        this.onlinePayFlag = true;
      } else if (res.statusCode == "002") {
        this.loader = false;
      }
    });
  }

  exit() {
    this.authService.logout();
    this.closeDialog(true)
  }

  // rzpLoading doubles as "Pay is still wanted" - closing/exiting the popup (or it being
  // destroyed) resets it, so a Razorpay script that finishes loading afterwards does not pop open.
  onSubmit() {
    if (this.rzpLoading) return;
    this.loader = false;
    this.rzpLoading = true;
    this.razorpayLoader.load().then(() => {
      if (!this.rzpLoading) return;
      this.rzpLoading = false;
      this.payWithRazor();
    }, () => {
      if (!this.rzpLoading) return;
      this.rzpLoading = false;
      this.snackbar.open('Could not load the payment page. Please check your internet and try again.', '', { duration: 4000 });
    });
  }

  ngOnDestroy() {
    this.rzpLoading = false;
  }


  payWithRazor() {
    console.log("payWithRazor---------------", this.paydata);
    // Razorpay keeps its popup open after a failed attempt so the user can retry on the same
    // order, so a failure is only remembered here, not reported - reporting it marks the order
    // TXN_FAILURE, and a retry that then succeeds no longer finds it PENDING (paid, plan not
    // activated). The final outcome goes out from handler (paid) or ondismiss (gave up).
    let paymentFailed = false;

    const options: any = {
      key: this.paydata.apiKey,
      amount: this.paydata.paidAmount,
      currency: 'INR',
      name: this.paydata?.companyName,
      description: '',
      // image: './assets/logo.png', // company logo or product image
      order_id: this.paydata.ORDER_ID,
      // callback_url: "http://localhost:5200/pay/companyPaymentResponse",
      modal: {
        escape: false,
      },
      notes: {
      },
      theme: {
        color: '#0c238a'
      }
    };
    options.modal.ondismiss = (() => {
      console.log('Transaction cancelled.');
      options.razorpay_payment_status = paymentFailed ? 'payment_failed' : 'cancelled';
      this.subExpiredService.razorPayResponse(options).subscribe(res => {
        this.closePaymentModel()

      })
    });

    options.handler = ((response, error) => {
      options.razorpay_order_id = response.razorpay_order_id;
      options.razorpay_payment_id = response.razorpay_payment_id;
      options.razorpay_signature = response.razorpay_signature;
      options.razorpay_payment_status = 'completed';
      console.log(response);
      console.log(options);

      this.subExpiredService.razorPayResponse(options).subscribe(res => {
        this.closePaymentModel()

      })
    });


    const rzp = new this.subExpiredService.nativeWindow.Razorpay(options);
    rzp.open();

    //On Payment failed
    rzp.on('payment.failed', () => {
      paymentFailed = true;
    });
  }

  closePaymentModel() {
    this.onlinePayFlag = false;
    this.renewPlan = false;
    this.closeDialog(true)
  }

  messageContent() {


    if (this.InputObj.daysRemaining == 30) {
      this.message = `You have ${this.InputObj.daysRemaining} Days remaining. Renew now and get software at same amount`
    }
    if (this.InputObj.daysRemaining == 15) {
      const originalPrice = 5000;
      const sealingPrice = 3000;
      const discount = ((originalPrice - sealingPrice) / originalPrice) * 100;
      this.message = ` ${this.InputObj.daysRemaining} Days Left Mega Offer Renew now and get flat ${discount}% discount`
    }
    if (this.InputObj.daysRemaining == 10) {
      this.message = `${this.InputObj.daysRemaining} Days Left Renew now and get software at same amount`
    }
    if (this.InputObj.daysRemaining == 5) {
      this.message = `Warning: Only ${this.InputObj.daysRemaining} days left! Don't Miss the chance Renew now at same price`
    }
    if (this.InputObj.daysRemaining == 3) {
      this.message = `You have ${this.InputObj.daysRemaining} Days remaining. Unbelievable but true You Are the lucky customer..... Click on Renew and unlock the grand discount `
    }
    if (this.InputObj.daysRemaining <= 0) {
      this.message = `Warning: Only ${this.InputObj.daysRemaining} days left! Please Renew Your Subscription to Continue`
    }
  }

}
